import { KeyboardDatePicker } from '@material-ui/pickers';
import React, { useState } from 'react';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
import { commonPropTypes, createCommonProps } from '../utils';
const COMPONENT_NAME = 'MuiKeyboardDatePicker';
const MuiKeyboardDatePicker = (inProps)=>{
    const [pickerOpen, setPickerOpen] = useState(false);
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    return /*#__PURE__*/ React.createElement(KeyboardDatePicker, {
        ...createCommonProps(props),
        onClick: ()=>setPickerOpen(true),
        onClose: ()=>setPickerOpen(false),
        open: pickerOpen,
        openOnlyByIcon: true
    });
};
MuiKeyboardDatePicker.propTypes = commonPropTypes;
export default MuiKeyboardDatePicker;
